import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { UntypedFormGroup, UntypedFormBuilder, AbstractControl, UntypedFormControl, Validators } from '@angular/forms'
import { Observable, Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import { MatOption } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-report-templates',
  templateUrl: './report-templates.component.html',
  styleUrls: ['./report-templates.component.scss']
})
export class ReportTemplatesComponent implements OnInit {


  @Input() selectReportTemplateIds: number[] = [];
  @Input() isMultiple: boolean = true;
  @Input() required: boolean = false;
  @Input('disabled') disabled: boolean;
  @Output() eventEmitterReportTemplates = new EventEmitter<ReportTemplatesComponent[]>();
  @ViewChild('matSelect') matSelect: MatSelect;
  reportTemplateForm: UntypedFormGroup;
  selectReportTemplate = new UntypedFormControl('', Validators.required);
  reportTemplateIds: number[] = [];
  selectedReportTemplates: string[] = [];
  selectedReport: string = '';
  selectedValue: number = 1;
  selectedOptionName: string = '';

  loaded$: Observable<boolean>;
  isLoading: boolean = false;



  constructor(private fb: UntypedFormBuilder) {

    this.reportTemplateForm = this.fb.group({
      reportTemplateSelect: [''],
      filter: ['']
    });

  }

  ngOnInit(): void {
  }

  loadData(open: any) {
  }


    select(selection: any) {
      this.selectedReportTemplates = selection;
      console.log('selected report templates:')
      console.log(this.selectedReportTemplates)

      console.log(this.matSelect.options.find(option => option.value === this.selectedReportTemplates)?.viewValue)
    
      const selectedTest = this.matSelect.options.find(option => option.value === this.selectedReportTemplates);
      if (selectedTest)
      {
       this.selectedReport = selectedTest?.viewValue;
       this.selectedValue = selectedTest?.value;
    }
    console.log(this.selectedReport)
    //if (
     // {
      //  this.selectedReport = (this.matSelect.options.find(option => option.value === this.selectedReportTemplates)?.viewValue);
     // }

      if (this.selectedOptionName) {
        console.log("got one")
        console.log(this.selectedOptionName)
        const selectedOptionElement = document.querySelector(`mat-option[value="${this.selectedOptionName}"]`);
        //   const selectedOption: MatSelect = this.matSelect.selected;
        //   console.log(selectedOption)

        // this.selectedOptionName = this.selectedReportTemplates;
        //this.matSelect.selected;

        console.log("now checking:")
        console.log(selectedOptionElement)
        if (selectedOptionElement) {
          console.log(selectedOptionElement?.textContent?.trim());
        }

      }
    }
  }
